import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { showErrorMsg, showInfoMsg, showSuccessMsg } from './ValidationHelper';
import rootAction from '../stateManagment/actions/rootAction';


export const AddProductToCart = (ProductId,
    Quantity, Price, productSelectedAttributes, AllAttributes, DefaultImage) => {
    let cartItems = [];
    try {


        cartItems = JSON.parse(localStorage.getItem("cartItems"))
        cartItems = cartItems ?? [];

        //--check if product already exists
        if (cartItems?.filter(obj => obj.ProductId == ProductId).length > 0) {
            showInfoMsg("Product already exists in your cart!");
            return false;
        } else {
            cartItems.push({
                ProductId: ProductId,
                productSelectedAttributes: productSelectedAttributes,
                Quantity: Quantity,
                Price:  productSelectedAttributes[0] && productSelectedAttributes[0].AdditionalPrice > 0?  productSelectedAttributes[0].AdditionalPrice: Price,
                ShippingCharges: 0,
                DefaultImage: DefaultImage
            });

            ;



            //--store in storage
            localStorage.setItem("cartItems", JSON.stringify(cartItems));

            // showSuccessMsg("Added to the cart!");
            return JSON.stringify(cartItems);;
        }
    }
    catch (err) {
        ;
        showErrorMsg("An error occured. Please try again!");
        return false;
    }



};

export const AlreadyAddedProductToCart = (ProductId) => {
    let cartItems = [];
    try {


        cartItems = JSON.parse(localStorage.getItem("cartItems"))
        let Product = cartItems?.filter(obj => obj.ProductId == ProductId);
        //--check if product already exists
        if (Product.length > 0) {

            return Product;
        } else {
            return false;
        }
    }
    catch (err) {
        return false;
    }



};


export const AddCustomerWishList = (ProductId, ProductName, Price, DiscountedPrice, DiscountId,
    IsDiscountCalculated, CouponCode,
    SizeId, SizeShortName, ColorId, ColorName, Quantity, DefaultImage) => {
    let customerWishList = [];
    try {


        customerWishList = JSON.parse(localStorage.getItem("customerWishList"))
        customerWishList = customerWishList ?? [];

        //--check if product already exists
        if (customerWishList?.filter(obj => obj.ProductId == ProductId).length > 0) {
            showInfoMsg("Product already exists in your wish list!");
            return JSON.stringify(customerWishList);
        } else {
            customerWishList.push({
                ProductId: ProductId,
                ProductName: ProductName,
                Price: Price,
                DiscountedPrice: DiscountedPrice,
                DiscountId: DiscountId,
                IsDiscountCalculated: IsDiscountCalculated,
                CouponCode: CouponCode,
                SizeId: SizeId,
                SizeShortName: SizeShortName,
                ColorId: ColorId,
                ColorName: ColorName,
                Quantity: Quantity,
                ShippingCharges: 0,
                DefaultImage: DefaultImage
            });

            ;

            showSuccessMsg("Added to your wish list!");
            return JSON.stringify(customerWishList);;
        }
    }
    catch (err) {
        ;
        showErrorMsg("An error occured. Please try again!");
        return JSON.stringify(customerWishList);;
    }



};